<script lang="ts" setup>
	type ImageFrameClass = {
		wrapper: Partial<{
			base: string
			display: string
			overflow: string
			height: string
			padding: string
		}>
		frame: Partial<{
			base: string
			display: string
			height: string
			width: string
			border: string
			rounded: string
		}>
		motionItem: Partial<{
			base: string
			position: string
			height: string
			width: string
			rounded: string
			background: string
			top: string
			animationName: string
		}>
		pictureWrapper: Partial<{
			base: string
			translate: string
		}>
		img: Partial<{
			translate: string
			height: string
			object: string
			width: string
			rounded: string
		}>
	}
	const config: ImageFrameClass = {
		wrapper: {
			base: '',
			display: 'inline-flex flex-col items-center flex-none',
			overflow: 'md:overflow-visible',
			height: 'min-h-[350px]  xl:min-h-max  ',
			padding: 'pt-5  xl:pt-0 '
		},
		frame: {
			base: 'relative',
			display: ' flex flex-col ',
			height: 'min-h-[15em] xl:min-h-[480px]',
			width: 'sm:min-w-[250px] w-full',
			border: 'border border-warning-20',
			rounded: 'rounded-[20px]'
		},
		motionItem: {
			base: '',
			position: 'absolute',
			height: 'h-[20px]',
			width: 'w-[20px] ',
			rounded: 'rounded-full',
			background: 'bg-warning-20 ',
			animationName: 'slidy'
		},
		pictureWrapper: {
			base: 'w-full',
			translate: ' translate-y-[46px] -translate-x-5'
		},
		img: {
			translate: 'translate-y-[20px]',
			height: 'sm:max-h-[480.42px] xl:h-full sm:h-[15em]  max-h-[290px]',
			object: 'object-cover',
			width: ' w-full',
			rounded: 'rounded-xl'
		}
	}
	const { wrapper, frame, motionItem, pictureWrapper, img } = config

	defineProps<{
		src?: {
			lg?: string
			sm: string
		}
		ui?: Partial<ImageFrameClass>
	}>()
</script>

<template>
	<div
		:class="[
			ui?.wrapper?.base ?? wrapper.base,
			ui?.wrapper?.display ?? wrapper.display,
			ui?.wrapper?.height ?? wrapper.height,
			ui?.wrapper?.overflow ?? wrapper.overflow,
			ui?.wrapper?.padding ?? wrapper?.padding,
			''
		]"
	>
		<div
			:class="[
				ui?.frame?.base ?? frame.base,
				ui?.frame?.border ?? frame.border,
				ui?.frame?.display ?? frame.display,
				ui?.frame?.height ?? frame.height,
				ui?.frame?.width ?? frame.width,
				ui?.frame?.rounded ?? frame.rounded
			]"
		>
			<div
				:class="[
					ui?.motionItem?.animationName ?? motionItem.animationName,
					ui?.motionItem?.background ?? motionItem.background,
					ui?.motionItem?.base ?? motionItem.base,
					ui?.motionItem?.height ?? motionItem.height,
					ui?.motionItem?.position ?? motionItem.position,
					ui?.motionItem?.rounded ?? motionItem.rounded,
					ui?.motionItem?.top ?? motionItem.top,
					ui?.motionItem?.width ?? motionItem.width
				]"
			>
				<slot name="animate-icon" />
			</div>

			<slot name="image">
				<picture
					:class="[
						ui?.pictureWrapper?.base ?? pictureWrapper.base,
						ui?.pictureWrapper?.translate ?? pictureWrapper.translate
					]"
				>
					<source
						media="(min-width:1280px)"
						:srcset="src?.lg ?? ''"
						:class="[ui?.img?.height ?? img.height, ui?.img?.object ?? img.object]"
					/>
					<nuxt-img
						provider="cloudinary"
						:src="src?.sm ?? ''"
						alt="Flowers"
						:class="[
							ui?.img?.height ?? img.height,
							ui?.img?.object ?? img.object,
							ui?.img?.rounded ?? img.rounded,
							ui?.img?.translate ?? img.translate,
							ui?.img?.width ?? img.width
						]"
						loading="lazy"
					/>
				</picture>
			</slot>
		</div>
	</div>
</template>

<style scoped>
	.slidy {
		--left-cordinate: 99.1%;
		transform-origin: center;
		perspective-origin: center;
		animation: movement 20s linear infinite;
		transition: 15s linear;
		left: 2%;
		@apply flex justify-center items-center text-xs text-white;
	}

	@keyframes movement {
		0% {
			left: 2%;
			top: -3%;
			transform: rotate(5deg);
		}
		25% {
			left: var(--left-cordinate);
			top: -3%;
			transform: rotate(0deg);
		}
		26% {
			transform: rotate(90deg);
			left: var(--left-cordinate);
			top: -3%;
		}
		50% {
			left: var(--left-cordinate);
			top: 98%;
			transform: rotate(90deg);
		}
		51% {
			transform: rotate(180deg);
		}

		75% {
			left: -1%;
			top: 98%;
			transform: rotate(180deg);
		}
		76% {
			transform: rotate(270deg);
		}

		100% {
			left: -1%;
			top: 0%;
			transform: rotate(270deg);
		}
	}
	@media screen and (max-width: 768px) {
		.slidy {
			--left-cordinate: 98%;
		}
	}
</style>
